import React, { useEffect, useState } from 'react';
import { useApi } from '../hooks/useApi';
import toast from 'react-hot-toast';
import { Copy, RefreshCw, Code2 } from 'lucide-react';

export default function CodeGen() {
  const api = useApi();
  const [cities, setCities] = useState([]);
  const [books, setBooks] = useState([]);
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('cities');

  useEffect(() => { load(); }, []);
  async function load() {
    setLoading(true);
    const [c, b, v] = await Promise.all([
      api.get('/cities'),
      api.get('/books'),
      api.get('/categories')
    ]);
    if (c) setCities(c.cities?.filter(x => x.is_active) || []);
    if (b) setBooks(b.books?.filter(x => x.is_active) || []);
    if (v) setCats(v.categories || []);
    setLoading(false);
  }

  function copy(text) {
    navigator.clipboard.writeText(text).then(() => toast.success('Copy ho gaya!'));
  }

  // Cities code generate
  const citiesCode = `// cities.js — Auto Generated\nconst CITIES = {\n${cities.map(c => `  '${c.code}': { name: '${c.name}', link: '${c.link || ''}' }`).join(',\n')}\n};\n\nmodule.exports = CITIES;`;

  // Books code generate
  const booksCode = `// books.js — Auto Generated\nconst BOOKS = [\n${books.map(b => `  { title: '${b.title}', link: '${b.link || ''}' }`).join(',\n')}\n];\n\nmodule.exports = BOOKS;`;

  // Video categories code generate
  const catsCode = `// categories.js — Auto Generated\nconst VIDEO_CATS = [\n${cats.map(c => {
    const mozos = JSON.parse(c.mozos || '[]');
    return `  {\n    title: '${c.title}',\n    mozos: [${mozos.map(m => `'${m}'`).join(', ')}]\n  }`;
  }).join(',\n')}\n];\n\nmodule.exports = VIDEO_CATS;`;

  const tabs = [
    { key: 'cities', label: '🕌 Cities', code: citiesCode, count: cities.length },
    { key: 'books', label: '📚 Books', code: booksCode, count: books.length },
    { key: 'cats', label: '📁 Categories', code: catsCode, count: cats.length },
  ];

  const active = tabs.find(t => t.key === tab);

  return (
    <div className="page">
      <div className="page-header">
        <div className="section-title">💻 Code Generator</div>
        <div className="section-sub">Database se bot ke liye ready-to-use code generate karein</div>
      </div>

      <div style={{ display: 'flex', gap: 4, marginBottom: 20, borderBottom: '1px solid var(--border)' }}>
        {tabs.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)} style={{
            padding: '8px 16px', background: 'none', border: 'none', cursor: 'pointer',
            fontSize: 13, fontWeight: 500,
            borderBottom: tab === t.key ? '2px solid var(--emerald-400)' : '2px solid transparent',
            color: tab === t.key ? 'var(--emerald-300)' : 'var(--text-muted)', marginBottom: -1,
            transition: 'all 0.15s'
          }}>
            {t.label} <span style={{ fontSize: 11, opacity: 0.6 }}>({t.count})</span>
          </button>
        ))}
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 40 }}><span className="spinner" /></div>
      ) : (
        <div className="card">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Code2 size={14} style={{ color: 'var(--emerald-400)' }} />
              <span className="code-file-tag">{tab}.js</span>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-ghost btn-sm" onClick={load}>
                <RefreshCw size={13} /> Refresh
              </button>
              <button className="btn btn-primary btn-sm" onClick={() => copy(active.code)}>
                <Copy size={13} /> Copy Code
              </button>
            </div>
          </div>
          <div className="code-block">{active.code}</div>
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 10 }}>
            💡 Yeh code copy kar ke bot ke <code style={{ color: 'var(--emerald-300)' }}>src/data/{tab}.js</code> mein paste karein
          </div>
        </div>
      )}
    </div>
  );
}